import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for allActions query
 */
export interface AllActionsVariables {
  before?: string;
  after?: string;
  first?: number;
  last?: number;
  type?: string;
}

/**
 * Page info structure for pagination
 */
export interface ActionsPageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  endCursor: string | null;
  startCursor: string | null;
}

/**
 * Field map config reference
 */
export interface ActionFieldMapConfig {
  id: string;
}

/**
 * Action node structure
 */
export interface ActionNode {
  fieldMapConfig: ActionFieldMapConfig | null;
  type: string;
  id: string;
}

/**
 * Action edge structure
 */
export interface ActionEdge {
  node: ActionNode;
}

/**
 * All actions connection structure
 */
export interface AllActionsConnection {
  pageInfo: ActionsPageInfo;
  totalCount: number;
  edges: ActionEdge[];
}

/**
 * Response structure for allActions query
 */
export interface AllActionsResponse {
  allActions: AllActionsConnection;
}

const allActions: DocumentNode = gql`
  query AllActions($before: String, $after: String, $first: Int, $last: Int, $type: String) {
    allActions(before: $before, after: $after, first: $first, last: $last, type: $type) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      totalCount
      edges {
        node {
          fieldMapConfig {
            id
          }
          type
          id
        }
      }
    }
  }
`;

export default allActions;
